import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { combineLatest, merge, Observable, Subject } from 'rxjs';
import { takeUntil, take, skip, tap, distinctUntilChanged } from 'rxjs/operators';
import {
  OptionDropdown,
  SelectControl,
} from '../../models/OptionDropdownSelect';
import { createControl } from '../../utilities/formUtilities';
import { AchTransactionDetailsForm, CheckTransactionDetailsForm, ItTransactionDetailsForm, WireTransactionDetailsForm } from '../../models/form/TransactionFormGroup';
import { Store } from '@ngrx/store';
import { selectTrustTaxCategorySelected } from '../../reducers';

@Component({
  standalone: false,
  selector: 'mm-trust-tax-code',
  templateUrl: './trust-tax-code.component.html',
  styleUrls: ['./trust-tax-code.component.scss'],
})
export class TrustTaxCodeComponent implements OnInit, OnDestroy {
  @Input() parentForm: FormGroup<CheckTransactionDetailsForm | WireTransactionDetailsForm | ItTransactionDetailsForm | AchTransactionDetailsForm>;
  @Input() codes: Observable<string[]>;
  private controlName = 'trustTaxCode';
  private destroy$ = new Subject<void>();
  clearInput: boolean = false;
  updateMap: boolean = false;
  positionLotsPhase2EnabledFsg: boolean = false;
  previousCategorySelected: string;
  transactionType: string;
  taxCodeDropdownModel: SelectControl = {
    controlName: this.controlName,
    title: 'Trust tax code',
    validationMessage: 'Trust tax code needs to be selected',
    options: [],
  };
  constructor(private store: Store) { }

  ngOnInit(): void {
    createControl(this.parentForm, this.controlName, '', [Validators.required]);

    this.store.select(selectTrustTaxCategorySelected).pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((previousCategory, currentCategory) =>
        previousCategory === currentCategory && !!currentCategory
      ),
      skip(1)
    ).subscribe(_ => {
        this.taxCodeControl?.setValue('', { emitEvent: false });
    });

    this.codes.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged((previousCodes, currentCodes) =>
        JSON.stringify(previousCodes) === JSON.stringify(currentCodes)
      ),
    ).subscribe(codes => {
      this.taxCodeDropdownModel.options = codes.map(
        (code) => new OptionDropdown(code, code)
      );
    });
  }

  ngOnDestroy(): void {
    this.parentForm?.removeControl('trustTaxCode');

    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  get taxCodeControl(): FormControl<string> | undefined {
    return this.parentForm?.get(this.controlName) as FormControl<string>;
  }

}
